import { Link } from "react-router-dom";
import SectionHeading from "../components/SectionHeading";
import "./Readmore.css";

const PARAGRAPHS = [
  "🎓 The early years are an important time in every child's life. At Agape Garden, we believe that children learn best when they are given the freedom to play, explore, ask questions, and try new things. Our preschool program focuses on helping children develop important early skills while making learning enjoyable and comfortable.",
  "🤝 Children also learn a lot from being around others. Through group activities, playtime, stories, and everyday interactions, they learn to share, communicate, cooperate, and understand the feelings of others. We encourage children to be kind, respectful, and confident while building healthy relationships with their friends and teachers.",
  "🌱 Our day care center is designed to provide children with a safe, caring, and comfortable place to spend their day. Along with learning and play, we give importance to rest, meals, routines, and personal care. We understand that every child is different, so we give them the attention and support they need to feel at home.",
  "🚀 Early childhood is not just about preparing children for school. It is about helping them become confident, curious, independent, and happy individuals. At Agape Garden, our aim is to give every child a strong and positive start through quality preschool education, caring day care, and plenty of opportunities to learn through play.",
];

export default function Readmore() {
  return (
    <article className="section readmore">
      <div className="container">
        <SectionHeading
          as="h1"
          plain="The Importance of Early Childhood"
          accent="Education"
        />

        <div className="readmore__card">
          <img src="/images/title.png" alt="" />
          {PARAGRAPHS.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>

        <Link to="/" className="btn btn--blue readmore__back">
          &larr; Back to home
        </Link>
      </div>
    </article>
  );
}